module.exports = __webpack_public_path__ + "img/badge-chimiotherapie-01.13197198.png";